import { AnswerEntityInterface } from '@types';

export type AnswerState = {
  isCreateAnswerLoading: boolean;
  isCurrentAnswerLoading: boolean;
  currentAnswer: AnswerEntityInterface;
  questionnaireData: object;
  answerData: string;
  isCurrentAnswerFailure: boolean;
  editMode: boolean;
  isAnswersLoading: boolean;
  answers: AnswerEntityInterface[];
  isAnswersFailure: boolean;
  limit: 10;
  offset: 0;
  total: 0;
  checkedAnswersIds: string[];
  navigateId: string;
  isEditingAnswerLoading: boolean;
  editingAnswer: AnswerEntityInterface;
  isEditingAnswerFailure: boolean;
  isDeletingAnswersLoading: boolean;
  isDeletingAnswersFailure: boolean;
  isMarkingAsSentLoading: boolean;
  isDateFromSaved: boolean;
  isDateToSaved: boolean;
  dateFromOld: null;
  dateToOld: null;
};

export const answerInitialState: AnswerState = {
  isCreateAnswerLoading: false,
  isCurrentAnswerLoading: false,
  currentAnswer: null,
  questionnaireData: null,
  answerData: null,
  isCurrentAnswerFailure: false,
  editMode: false,
  isAnswersLoading: false,
  answers: [],
  isAnswersFailure: false,
  limit: 10,
  offset: 0,
  total: 0,
  checkedAnswersIds: [],
  navigateId: null,
  //// PUT/DELETE/POST
  isEditingAnswerLoading: false,
  editingAnswer: null,
  isEditingAnswerFailure: false,
  isDeletingAnswersLoading: false,
  isDeletingAnswersFailure: false,
  isMarkingAsSentLoading: false,
  isDateFromSaved: false,
  isDateToSaved: false,
  dateFromOld: null,
  dateToOld: null,
};
